<!-- account-deletion-request.component.html -->
<div class="deletion-container">
  <h1>Solicitar eliminación de cuenta en <strong>The Campus</strong></h1>

  <p>
    Si ya no deseas usar <strong>The Campus</strong>, puedes solicitar la
    eliminación de tu cuenta completando el siguiente campo. Esta solicitud
    será enviada a nuestro equipo de soporte.
  </p>

  <form [formGroup]="deletionForm" (ngSubmit)="onSubmit()">
    <label for="email">Correo electrónico asociado a tu cuenta:</label>
    <input
      id="email"
      type="email"
      formControlName="email"
      placeholder="tucorreo@ejemplo.com"
    />

    <div
      *ngIf="
        deletionForm.controls.email.invalid &&
        deletionForm.controls.email.touched
      "
      class="error"
    >
      Ingresa un correo válido.
    </div>

    <button type="submit" [disabled]="deletionForm.invalid">
      Enviar solicitud
    </button>
  </form>

  <div *ngIf="submitted" class="confirmation">
    ✅ Tu solicitud ha sido enviada. Nuestro equipo de soporte la procesará en
    breve.
  </div>

  <section>
    <h2>¿Qué datos se eliminan?</h2>
    <ul>
      <li>Email del usuario</li>
      <li>Datos personales</li>
    </ul>
  </section>

  <!-- <footer>
    <p>Desarrollador: <strong>The Campus</strong></p>
    <p>Contacto: <a href="mailto:soporte@thecampus.app">soporte@thecampus.app</a></p>
  </footer> -->
</div>
